
/**
 * @info https://bootstrapious.com/p/bootstrap-sidebar
 */
$(document).ready(function () {
    $("#sidebar").mCustomScrollbar({
        theme: "minimal",
        setTop: '0px',
    });

    $('#dismiss, .overlay').on('click', function () {
        closeSideBar();
    });

    $('.menu-toggle').on('click', function () {
        $('#sidebar').addClass('active');
        $('.overlay').addClass('active');
        $('.collapse.in').toggleClass('in');
        $('a[aria-expanded=true]').attr('aria-expanded', 'false');
    });

    $('#chatFilterToggle, .chatFilterToggle').on('click', function(){
        $('.header__chat-history-filter').toggleClass('d-none');
        $('.chatFilterToggle').toggleClass('selected');
    })

    $(document).on('click', '.offlineMessageFilterToggle', function(){
        $('.header__offline-messages-filter').toggleClass('d-none');
        $('.offlineMessageFilterToggle').toggleClass('selected');
    })
});

window.closeSideBar = function() {
    $('#sidebar').removeClass('active');
    $('.overlay').removeClass('active');
}